import { useState, useEffect, createContext, useLayoutEffect } from "react";
import _debounce from 'lodash/debounce';
import Flats from "./Flats/Flats";
import ContainerSelect from "./Components/ContainerSelect";
import Offices from './Offices/Offices';
import Parking from './Parking/Parking';
import Storeroom from './Storeroom/Storeroom';
import Floors from './Floors/Floors';
import fetchApi from "./api/fetchApi";
import Loading from "./Components/Loading/Loading";
import InfoMessage from "./Components/NothingMatches";
import DefaultError from "./Components/ErrorBoundary/GeneralError";

export const Context = createContext({
    test: "test"
});

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const containers = {
    "default": isMobile ? [
      { type: "flats", text: "квартиры" },
      { type: "offices", text: "офисы" },
      { type: "parking", text: "парковки" },
      { type: "storeroom", text: "кладовки" },
    ] : [
      { type: "floors", text: "поэтажные планы" },
      { type: "flats", text: "квартиры" },
      { type: "offices", text: "офисы" },
      { type: "parking", text: "парковки" },
      { type: "storeroom", text: "кладовки" },
    ],
    "offices": [
      { type: "flats", text: "квартиры" },
      { type: "offices", text: "офисы" },
    ],
    "commercial": [
      { type: "floors", text: "поэтажные планы" },
      { type: "offices", text: "офисы" },
    ]
  }

  const [initialProps, setInitialProps] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [containersType, setContainersType] = useState("default");
  const [container, setContainer] = useState(containers["default"][0].type);
  const [facilityId, setFacilityId] = useState(0);

  const windowResizeHandler = _debounce(() => {
    setIsMobile(window.innerWidth < 768);
  }, 200)

  useEffect(() => {
    window.addEventListener('resize', windowResizeHandler)
    return () => {
      window.removeEventListener('resize', windowResizeHandler)
    }
  }, [windowResizeHandler])

  useLayoutEffect(() => {
    const initFetch = async () => {
      const facilityId = document.querySelector("[data-house-id]").getAttribute("data-house-id");
      setFacilityId(facilityId);
      setLoading(true);
      const {json, error} = await fetchApi('api/facility/' + facilityId);
      setLoading(false);

      setInitialProps(json, facilityId);
      setError(error);
    }

    initFetch();
    const containersType = document.querySelector("[data-containers-type]")?.getAttribute("data-containers-type");
    setContainersType(containersType || "default");
  }, []);

    return (
        <div className="room">
            <div className="room__wrap">
                <Context.Provider
                    value={{
                        initialProps,
                        facilityId,
                        containersType
                    }}
                >
                    { loading && <Loading/> }
                    <DefaultError>
                        <ContainerSelect
                            containers={containers[containersType]}
                            container={container}
                            setContainer={setContainer}
                        />
                        <div className="room__body-box" data-body-box data-house-id="79">
                            { container === "floors" && <Floors />}
                            { container === "flats" && <Flats />}
                            { container === "offices" && <Offices />}
                            { container === "parking" && <Parking />}
                            { container === "storeroom" && <Storeroom />}
                        </div>
                    </DefaultError>
                    </Context.Provider>
            </div>
        </div>
    );
}

export default App;
